import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ELoginAs } from '@aqx-core/common/api/auth';
import { AUTHENTICATION_ROUTES } from '@aqx-core/common/constants/router';
import { useLoginSignUpAction } from '@aqx-core/common/hooks/auth/use-login-sign-up-action';
import { useAuthLoading } from '@aqx-core/common/services/auth';
import { openUrl } from '@aqx-member/web/utils/url/open-url';

import AuthFormSecondaryAction from '../../shared/form-secondary-action';

interface ILoginSignUpAction {
  selectedTab: ELoginAs | undefined;
}

const LoginSignUpAction: FCC<ILoginSignUpAction> = ({ selectedTab }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const authLoginLoading = useAuthLoading();

  const { onPress, signUpText, dataTestId } = useLoginSignUpAction({
    selectedTab,
    navigateSignUpCRM: () => navigate(AUTHENTICATION_ROUTES.SIGN_UP_CRM),
    navigateSignUpDemo: () => navigate(AUTHENTICATION_ROUTES.SIGN_UP_DEMO),
    openUrlCallback: (url: string) => openUrl(url, '_blank')
  });

  if (!signUpText) {
    return null;
  }

  return (
    <AuthFormSecondaryAction
      infoText={t("Don't have an account?")}
      actionText={signUpText}
      onClickActionText={onPress}
      disabled={authLoginLoading}
      dataTestId={dataTestId}
    />
  );
};

export default LoginSignUpAction;
